import { render } from "./ChatbotIcon16.vue.js?vue&type=template&id=8e56e190!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ChatbotIcon16.vue?vue&type=template&id=8e56e190"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__